import { useState } from 'react';
import { toast } from 'sonner';
import { useAppDispatch } from '../redux/hooks';
import { fetchSearchedUser } from '../redux/SearchedUserReducer/searchedUserSlice';

export const useEmployeeSearch = () => {
    const dispatch = useAppDispatch();
    const [searchEmployeeId, setSearchEmployeeId] = useState("");
    const [hasSearched, setHasSearched] = useState(false);

    const performSearch = (employeeId: string) => {
        const normalizedId = employeeId.trim();

        if (!normalizedId) {
            toast.error("Please enter an employee ID");
            return;
        }

        setSearchEmployeeId(normalizedId);
        setHasSearched(true);
        dispatch(fetchSearchedUser(normalizedId));
        toast.info(`Searching for employee ID: ${normalizedId}`);
    };

    const handleSearch = async (e?: React.FormEvent) => {
        if (e) {
            e.preventDefault();
        }

        performSearch(searchEmployeeId);
    };

    const searchByEmployeeId = (employeeId: string) => {
        performSearch(employeeId);
    };

    const resetSearch = () => {
        setSearchEmployeeId("");
        setHasSearched(false);
    };

    return {
        searchEmployeeId,
        setSearchEmployeeId,
        hasSearched,
        handleSearch,
        searchByEmployeeId,
        resetSearch,
    };
};